var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Works.CoauthorPicker = function (superClass) {
  extend(CoauthorPicker, superClass);
  function CoauthorPicker() {
    return CoauthorPicker.__super__.constructor.apply(this, arguments);
  }
  CoauthorPicker.prototype.initialize = function (options) {
    this.searchInput = options.searchInput;
    this.searchView = new Search.CoauthorSearch(_.extend(options.searchOptions || {}, {
      el: this.searchInput,
      collection: this.collection
    }));
    this.inviteModalView = new Works.InviteCoauthorModal({
      collection: this.collection
    }).render();
    if (options.instantSave) {
      this.saveOnAnyChanges();
    }
    return this.searchView.$el.on('select2-footer-clicked', function (_this) {
      return function () {
        return _this.footerClicked();
      };
    }(this));
  };
  CoauthorPicker.prototype.footerClicked = function () {
    this.searchInput.select2('close');
    return this.inviteModalView.show();
  };
  CoauthorPicker.prototype.saveOnAnyChanges = function () {
    this.listenTo(this.collection, 'sort', _.debounce(function (_this) {
      return function () {
        return _this.collection.saveOrdering();
      };
    }(this), 500));
    this.listenTo(this.collection, 'add', function (_this) {
      return function (tag) {
        if (!tag.has('id')) {
          return tag.save();
        }
      };
    }(this));
    return this.listenTo(this.collection, 'remove', function (_this) {
      return function (tag) {
        if (tag.has('id')) {
          return tag.destroy();
        }
      };
    }(this));
  };
  return CoauthorPicker;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;